const styles = {
    progress: {
        marginLeft: 'calc(50% - 20px)',
        marginTop: 200
    },
    form: {
        maxWidth: 700,
        minWidth: 300,
        '& .MuiGrid-item': {
            paddingLeft: 0
        },
        '& .MuiFormHelperText-root': {
            position: 'absolute',
            top: 47
        }
    },
    grid: {
        margin: 0,
        width: '100%'
    },
    input: {
        width: '100%'
    },
    error: {
        color: 'red'
    },
    message: {
        marginTop: 10,
        marginBottom: 10,
    }
};

export default styles;